(() => {
  if (window.mpFomoInit) return;
  window.mpFomoInit = true;

  const palette = {
    violet: '#22003A',
    gold: '#D4A853',
    red: '#C4192E'
  };

  const pools = {
    firstNames: [
      'Sophie','Camille','Emma','Louise','Chloé','Léa','Inès','Manon','Sarah','Jade','Anaïs','Lina','Clara','Zoé','Mila','Charlotte','Juliette','Lucie','Pauline','Alicia',
      'Marine','Eva','Noémie','Céline','Margaux','Amélie','Laura','Morgane','Elsa','Valentine','Romane','Lola','Maëlys','Louna','Nina','Léna','Océane','Cassandra','Mélissa','Héloïse',
      'Agathe','Lison','Blandine','Maïa','Aya','Yasmine','Salomé','Élodie','Nora','Anastasia'
    ],
    cities: [
      'Lyon','Paris','Marseille','Toulouse','Bordeaux','Lille','Nantes','Nice','Rennes','Montpellier','Strasbourg','Grenoble','Dijon','Reims','Le Havre','Toulon','Angers','Tours','Annecy','Aix-en-Provence',
      'Clermont-Ferrand','Orléans','Metz','Rouen','Caen','Nancy','Perpignan','Brest','Avignon','La Rochelle'
    ]
  };

  function todayKey() {
    const d = new Date();
    return `${d.getUTCFullYear()}-${String(d.getUTCMonth()+1).padStart(2,'0')}-${String(d.getUTCDate()).padStart(2,'0')}`;
  }

  function hashToInt(str) {
    let h = 2166136261;
    for (let i=0;i<str.length;i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return (h >>> 0);
  }

  function seededBetween(seedStr, min, max) {
    const n = hashToInt(seedStr);
    const range = max - min + 1;
    return min + (n % range);
  }

  const stockBounds = {
    // by product id (string) in DOM, fallback applies
    default: [12, 28],
    gwp: [18, 40]
  };

  function getStockForKey(key) {
    const bounds = stockBounds[key] || stockBounds.default;
    const [min, max] = bounds;
    // appear to slowly decrease day to day, but stable within the day
    const base = seededBetween(`${todayKey()}|${key}|base`, min, max);
    const drift = seededBetween(`${todayKey()}|${key}|drift`, 0, 3);
    return Math.max(min, base - drift);
  }

  function applyStockCounters() {
    document.querySelectorAll('[data-mp-fomo-stock]').forEach((el) => {
      const key = el.getAttribute('data-mp-stock-key') || 'default';
      el.textContent = String(getStockForKey(key));
      el.style.color = palette.red;
    });
  }

  function formatParticipants(n) {
    // French style with thin space
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function applyParticipants() {
    document.querySelectorAll('[data-mp-participants]').forEach((el) => {
      const base = parseInt(el.getAttribute('data-mp-base') || '8500', 10);
      const perDay = seededBetween(`${todayKey()}|participants|inc`, 200, 400);
      // add progression through month (rough)
      const d = new Date();
      const day = d.getUTCDate();
      const val = base + perDay * Math.max(0, day - 1);
      el.textContent = `${formatParticipants(val)}+`;
    });
  }

  function applyRelativeDates() {
    document.querySelectorAll('[data-mp-relative-date]').forEach((el) => {
      const seed = el.getAttribute('data-mp-seed') || '0';
      const days = seededBetween(`${todayKey()}|review|${seed}`, 1, 12);
      el.textContent = `Il y a ${days} jour${days>1?'s':''}`;
    });
  }

  function tickCountdown() {
    document.querySelectorAll('[data-mp-countdown]').forEach((wrap) => {
      const endStr = wrap.getAttribute('data-mp-end');
      const end = Date.parse(endStr);
      if (Number.isNaN(end)) return;
      const now = Date.now();
      let ms = Math.max(0, end - now);
      const day = 86400000, hour = 3600000, min = 60000;
      const days = Math.floor(ms / day); ms -= days * day;
      const hours = Math.floor(ms / hour); ms -= hours * hour;
      const mins = Math.floor(ms / min);
      const dEl = wrap.querySelector('[data-mp-cd-days]');
      const hEl = wrap.querySelector('[data-mp-cd-hours]');
      const mEl = wrap.querySelector('[data-mp-cd-mins]');
      if (dEl) dEl.textContent = `${days}j`;
      if (hEl) hEl.textContent = `${hours}h`;
      if (mEl) mEl.textContent = `${mins}min`;
    });
  }

  // Toasts
  function startToasts() {
    const container = document.querySelector('[data-mp-toast-container]');
    if (!container) return;

    const productNames = ['Soin Love','Shampooing Sense','Water Glow','Roll-on Hair+','Routine Pro Réparatrice','Spray Protect'];

    function canShow() {
      const cartOpen = document.body.classList.contains('js-drawer-open-cart');
      return !cartOpen;
    }

    function showOne() {
      if (!canShow()) return;
      const name = pools.firstNames[seededBetween(`${todayKey()}|toast|name|${Date.now()}`, 0, pools.firstNames.length-1)];
      const city = pools.cities[seededBetween(`${todayKey()}|toast|city|${Date.now()}`, 0, pools.cities.length-1)];
      const prod = productNames[seededBetween(`${todayKey()}|toast|prod|${Date.now()}`, 0, productNames.length-1)];
      const mins = seededBetween(`${todayKey()}|toast|mins|${Date.now()}`, 1, 12);

      const item = document.createElement('div');
      item.className = 'mp-toast__item';
      item.innerHTML = `
        <div class="mp-toast__line1">🛒 ${name} de ${city} vient de commander ${prod}</div>
        <div class="mp-toast__line2">Il y a ${mins} min</div>
      `;
      container.appendChild(item);
      requestAnimationFrame(() => item.classList.add('is-show'));
      setTimeout(() => {
        item.classList.remove('is-show');
        setTimeout(() => item.remove(), 350);
      }, 5000);
    }

    // start after 10s
    setTimeout(() => {
      showOne();
      setInterval(() => {
        const delay = seededBetween(`${todayKey()}|toast|delay|${Date.now()}`, 30, 45);
        setTimeout(showOne, delay * 1000);
      }, 45000);
    }, 10000);
  }

  // Bundle ATC (handles list)
  async function addBundle(handlesCsv) {
    const handles = (handlesCsv || '').split(',').map(s => s.trim()).filter(Boolean);
    if (!handles.length) return;

    // resolve variants by fetching product JSON
    const items = [];
    for (const h of handles) {
      try {
        const r = await fetch(`/products/${encodeURIComponent(h)}.js`);
        if (!r.ok) continue;
        const p = await r.json();
        const v = (p.variants || []).find(v => v.available) || (p.variants || [])[0];
        if (v && v.id) items.push({id: v.id, quantity: 1});
      } catch (e) {}
    }
    if (!items.length) return;

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json', 'Accept':'application/json'},
      body: JSON.stringify({items})
    });

    // Open cart drawer if theme has toggle
    const toggle = document.querySelector('[data-cart-drawer-toggle]');
    if (toggle) toggle.dispatchEvent(new Event('click', {bubbles:true}));
  }

  function bindBundleButtons() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-mp-bundle-atc]');
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      btn.style.opacity = '0.75';
      addBundle(btn.getAttribute('data-mp-bundle-items')).finally(() => {
        btn.disabled = false;
        btn.style.opacity = '';
      });
    });
  }

  // Cart drawer GWP progress (65€)
  async function updateGwp() {
    const holder = document.querySelector('[data-mp-gwp]');
    if (!holder) return;

    let cart;
    try {
      const r = await fetch('/cart.js');
      cart = await r.json();
    } catch (e) {
      return;
    }

    const threshold = parseFloat(holder.getAttribute('data-mp-gwp-threshold') || '65');
    const total = (cart && cart.total_price ? cart.total_price : 0) / 100;
    const remaining = Math.max(0, threshold - total);
    const pct = Math.max(0, Math.min(100, (total / threshold) * 100));

    const bar = holder.querySelector('[data-mp-gwp-bar]');
    const txt = holder.querySelector('[data-mp-gwp-text]');
    if (bar) bar.style.setProperty('--mp-gwp', `${pct}%`);
    if (txt) {
      txt.textContent = remaining > 0
        ? `🎁 Plus que ${remaining.toFixed(0)}€ pour votre cadeau !`
        : `🎁 Cadeau débloqué !`;
    }
  }

  function bindCartEvents() {
    document.addEventListener('theme:cart:added', updateGwp);
    document.addEventListener('theme:cart:loaded', updateGwp);
    document.addEventListener('theme:cart:update', () => setTimeout(updateGwp, 350));
  }

  function init() {
    applyStockCounters();
    applyParticipants();
    applyRelativeDates();
    tickCountdown();
    setInterval(tickCountdown, 1000);
    bindBundleButtons();
    bindCartEvents();
    updateGwp();
    startToasts();

    // rotating announcement
    const slides = Array.from(document.querySelectorAll('[data-mp-announcement-slide]'));
    if (slides.length) {
      let idx = 0;
      slides.forEach((s,i) => s.classList.toggle('is-active', i===0));
      setInterval(() => {
        slides[idx].classList.remove('is-active');
        idx = (idx + 1) % slides.length;
        slides[idx].classList.add('is-active');
      }, 4000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
